var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcMaterial(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 20h20V0H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9FA0A0",
    d: "M5 16.669V3.331h5.833v4.32H15v9.018H5zm7.585-15.002h-7.69c-.86 0-1.562.709-1.562 1.582V16.75c0 .872.701 1.582 1.563 1.582h10.208c.862 0 1.563-.71 1.563-1.582V6.705l-4.082-5.038z"
  }))));
}

export default "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 20 20'%3E %3Cg fill='none' fill-rule='evenodd'%3E %3Cg%3E %3Cg%3E %3Cpath d='M0 20L20 20 20 0 0 0z' transform='translate(-20 -153) translate(20 153)'/%3E %3Cpath fill='%239FA0A0' d='M5 16.669V3.331h5.833v4.32H15v9.018H5zm7.585-15.002h-7.69c-.86 0-1.562.709-1.562 1.582V16.75c0 .872.701 1.582 1.563 1.582h10.208c.862 0 1.563-.71 1.563-1.582V6.705l-4.082-5.038z' transform='translate(-20 -153) translate(20 153)'/%3E %3C/g%3E %3C/g%3E %3C/g%3E %3C/svg%3E";
export { SvgIcMaterial as ReactComponent };